/* Nordestic · Kategorieseite: Filter/Sortierung sofort anwenden, „Weitere Produkte laden“ ohne Seitenwechsel */
(() => {
  const form = document.querySelector('[data-np-col-form]');
  if (form) form.addEventListener('change', e => { if (e.target.matches('[data-np-col-auto]')) form.requestSubmit ? form.requestSubmit() : form.submit(); });
  document.querySelectorAll('.np-col-dd').forEach(d => d.addEventListener('toggle', () => { if (d.open) document.querySelectorAll('.np-col-dd[open]').forEach(o => { if (o !== d) o.open = false; }); }));
  document.addEventListener('click', e => { if (!e.target.closest('.np-col-dd')) document.querySelectorAll('.np-col-dd[open]').forEach(o => { o.open = false; }); });
  document.addEventListener('click', async e => {
    const a = e.target.closest('[data-np-col-more]');
    if (!a) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true'); a.textContent = 'Lädt …';
    try {
      const html = await fetch(a.href).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.querySelector('[data-np-col-grid]');
      doc.querySelectorAll('[data-np-col-grid] > .np-pc').forEach(n => grid.appendChild(document.importNode(n, true)));
      const next = doc.querySelector('[data-np-col-more]');
      if (next) { a.href = next.href; a.textContent = 'Weitere Produkte laden'; a.removeAttribute('aria-busy'); } else a.closest('.np-rv-more-wrap')?.remove();
    } catch { location.href = a.href; }
  });
})();

/* Kategorieseite v2: Lieferdatum, Einleitung aufklappen, Form-Knöpfe, Bilder-Punkte (01.10.2026) */
(() => {
  // Lieferdatum (Zeitzone Berlin): „Lieferung bis Di., 7. Okt.“ bzw. „Lieferung 6.–8. Okt.“
  const berlin = () => { const p = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date()); return new Date(p + 'T12:00:00'); };
  const add = (d, n, work) => { const r = new Date(d); let k = 0; while (k < n) { r.setDate(r.getDate() + 1); if (!work || (r.getDay() % 6)) k++; } return r; };
  const fd = (d, o) => new Intl.DateTimeFormat('de-DE', o).format(d);
  document.querySelectorAll('[data-np-delivery]').forEach(el => {
    const [lo, hi, unit] = el.dataset.npDelivery.split(','); const work = unit === 'workdays';
    const a = add(berlin(), +lo, work), b = add(berlin(), +hi, work);
    el.textContent = `Kostenlose Lieferung bis ${fd(b, {weekday: 'short', day: 'numeric', month: 'short'})}`;
  });
  // Einleitung auf dem Handy auf 2 Zeilen, „Mehr lesen“ nur wenn nötig
  document.querySelectorAll('[data-np-col-intro]').forEach(p => {
    const btn = p.parentElement.querySelector('[data-np-col-more-text]'); if (!btn) return;
    const check = () => { btn.hidden = p.classList.contains('is-open') ? false : p.scrollHeight <= p.clientHeight + 2; };
    btn.addEventListener('click', () => { const open = p.classList.toggle('is-open'); btn.setAttribute('aria-expanded', String(open)); btn.textContent = open ? 'Weniger' : 'Mehr lesen'; });
    check(); addEventListener('resize', check, {passive: true});
  });
  // Form-Knöpfe: Kacheln ein-/ausblenden, Adresse merkt sich die Auswahl (?form=rund)
  document.querySelectorAll('.np-col-filter').forEach(group => {
    const grid = document.querySelector('[data-np-col-grid]'); if (!grid) return;
    const apply = key => {
      group.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String((b.dataset.npFilter || '') === key)));
      const cards = [...grid.querySelectorAll('.np-pc')];
      cards.forEach(c => { c.hidden = !!key && c.dataset.group !== key; c.classList.remove('is-last-odd'); });
      const shown = cards.filter(c => !c.hidden);
      shown.forEach((c, i) => c.style.setProperty('--o', String((i + 1) * 2)));
      grid.classList.toggle('is-filtered', !!key);
      if (key && shown.length % 2) shown[shown.length - 1].classList.add('is-last-odd');
      const u = new URL(location.href); if (key) u.searchParams.set('form', key); else u.searchParams.delete('form');
      try { history.replaceState(null, '', u); } catch {}
    };
    group.addEventListener('click', e => { const b = e.target.closest('button'); if (b) apply(b.dataset.npFilter || ''); });
    const start = new URL(location.href).searchParams.get('form'); if (start && group.querySelector(`[data-np-filter="${start}"]`)) apply(start);
  });
  // Punkte unter wischbaren Bildern
  document.querySelectorAll('.np-pc-track').forEach(t => {
    const dots = t.parentElement.querySelectorAll('.np-pc-dots i');
    t.addEventListener('scroll', () => { const i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth)); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }, {passive: true});
  });
})();

/* v5: Kachelbilder sanft einblenden */
(() => {
  document.querySelectorAll('[data-np-fade]').forEach(m => {
    const img = m.querySelector('img'); if (!img) return m.classList.add('is-loaded');
    const done = () => m.classList.add('is-loaded');
    if (img.complete && img.naturalWidth) done(); else { img.addEventListener('load', done, {once: true}); img.addEventListener('error', done, {once: true}); }
  });
})();

/* v10: Werkstatt-Film – lädt erst beim Hinscrollen, läuft stumm in Schleife, pausierbar, respektiert „weniger Bewegung“ */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-np-film]').forEach(fig => {
    const v = fig.querySelector('video'), btn = fig.querySelector('[data-np-film-toggle]');
    let userPaused = reduce;
    const sync = () => { fig.classList.toggle('is-paused', v.paused); btn.setAttribute('aria-label', v.paused ? 'Film abspielen' : 'Film anhalten'); };
    const play = () => { if (userPaused) return; v.play().catch(() => {}); };
    btn.addEventListener('click', () => { if (v.paused) { userPaused = false; v.play().catch(() => {}); } else { userPaused = true; v.pause(); } });
    v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
    if (!('IntersectionObserver' in window)) return play();
    new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; play(); } else v.pause(); }), {rootMargin: '200px 0px'}).observe(fig);
  });
})();

/* v11: Schritte im Werkstattfilm mitlaufen lassen (Zuschnitt · Kante · Schliff · Öl) */
(() => {
  document.querySelectorAll('[data-np-film-steps]').forEach(ol => {
    const v = ol.closest('[data-np-film]')?.querySelector('video'); if (!v) return;
    const at = ol.dataset.npFilmSteps.split(',').map(Number), li = [...ol.children];
    v.addEventListener('timeupdate', () => { let k = 0; at.forEach((s, i) => { if (v.currentTime >= s) k = i; }); li.forEach((l, i) => l.classList.toggle('is-on', i === k)); });
  });
})();

/* R135 · Kundenfotos aus den Bewertungen (Judge.me), ungeschnitten und mehr als bisher */
(() => {
  const strip = document.querySelector('.np-voices-strip[data-n-ugc]');
  if (!strip) return;
  const shop = strip.dataset.shop, token = strip.dataset.token;
  const prods = (strip.dataset.products || '').split('|').map(x => x.trim()).filter(Boolean).map(x => { const i = x.indexOf(':'); return {id: x.slice(0, i), name: x.slice(i + 1)}; });
  if (!shop || !token || !prods.length) return;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
  const load = async p => {
    try {
      const u = new URL('https://judge.me/api/v1/widgets/product_review');
      u.search = new URLSearchParams({shop_domain: shop, api_token: token, external_id: p.id, json_request: 'true', page: '1', per_page: '30'});
      const j = await fetch(u).then(r => r.ok ? r.json() : null);
      return ((j && j.reviews) || []).filter(r => Number(r.rating) >= 4 && (r.pictures_urls || []).length).map(r => ({p, r}));
    } catch { return []; }
  };
  let started = false;
  const run = async () => {
    if (started) return; started = true;
    const lists = await Promise.all(prods.map(load));
    const out = [];
    for (let k = 0; k < 4 && out.length < 12; k++) for (const l of lists) if (l[k] && out.length < 12) out.push(l[k]);
    if (out.length < 4) return;
    strip.innerHTML = out.map(({p, r}) => { const pic = r.pictures_urls[0]; const src = pic.huge || pic.original || pic.compact; return src ? `<figure><img alt="Kundenfoto von ${esc(r.reviewer_name || 'einer Kundin oder einem Kunden')}" loading="lazy" decoding="async" src="${esc(src)}"><figcaption>${esc(p.name)}</figcaption></figure>` : ''; }).join('');
    strip.classList.add('is-live'); strip.scrollLeft = 0;
  };
  if ('IntersectionObserver' in window) { const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); run(); } }, {rootMargin: '700px'}); io.observe(strip); } else run();
})();
